import { Base } from './base.model';

export class SiteDocusignEnvelope extends Base {
  public siteId: number;
  public description: string;
  public envelopeId: string;
  public status: string;
  public recipient: string;
  public sentDate: Date;
}
